import { Component, Prop, h } from '@stencil/core';

/**
 * Footers signify the end of page content and provide required information that a user may have missed. Footers should stay thematically the same throughout a digital product, in the effort to create a cohesive user experience.
 */
@Component({
  tag: 'som-footer',
  styleUrl: 'som-footer.scss',
  shadow: true,
})
export class SomFooter {
  /**
   * Determines whether to use the light or dark theme. Dark is the default but adding the light parameter will switch it to the light theme.
   */
  @Prop() light: boolean = false;

  render() {
    return (
      <footer class={`footer ${this.light ? 'light' : ''}`} role="contentinfo" aria-label="footer">
        <div class="footer__copyright">
          Copyright {new Date().getFullYear()}{' '}
          <a href="http://www.michigan.gov" target="_blank" rel="noopener noreferrer">
            State of Michigan
          </a>
        </div>
        <div role="list" class="footer__nav">
          <slot />
          <som-footer-item show-divider="false">
            <a target="_blank" href="https://www.michigan.gov/policies" rel="noopener noreferrer">
              Policies
            </a>
          </som-footer-item>
        </div>
      </footer>
    );
  }
}
